module.exports = __webpack_public_path__ + "/images/mockup-llista.fd63aff.png";